// Listenin sezonu (baslik + etiketten) ve sezonun gecip gecmedigi (kullanici 2026-10-26, IP
// temizligi: "sezonu gecmis" listeler once pasife). Sezon bitisinden 7 gun once "gecmis" sayilir:
// kargo suresi yuzunden alici zamaninda alamaz (Cadilar Bayrami 26 Ekim'de 29 Ekim-3 Kasim teslim).

interface Season { name: string; re: RegExp; start: [number, number]; end: [number, number] }

// Sira onemli: ilk eslesen sezon (Noel'deki "winter" kis sezonu, Cadilar Bayrami'ndaki "fall" sonbahar)
export const SEASONS: Season[] = [
  { name: "Cadılar Bayramı", re: /hallow|spooky|ghost|pumpkin|witch|skeleton|trick or treat|\bboo\b|day of the dead|dia de|all saints|all souls/i, start: [8, 15], end: [10, 31] },
  { name: "Şükran Günü", re: /thanksgiving|friendsgiving|turkey day|\bturkey\b/i, start: [10, 1], end: [11, 27] },
  { name: "Noel/Kış", re: /christmas|xmas|santa|reindeer|grinch|holiday season|winter|snowman|snow/i, start: [10, 1], end: [12, 25] },
  { name: "Sevgililer", re: /valentine|galentine/i, start: [1, 1], end: [2, 14] },
  { name: "St Patrick", re: /st\.? ?patrick|shamrock/i, start: [2, 15], end: [3, 17] },
  { name: "Paskalya", re: /easter|\bbunny\b/i, start: [2, 20], end: [4, 20] },
  { name: "Anneler Günü", re: /mother'?s day/i, start: [4, 1], end: [5, 11] },
  { name: "Mezuniyet", re: /graduat|class of 20\d\d|senior 20\d\d/i, start: [3, 15], end: [6, 15] },
  { name: "Babalar Günü", re: /father'?s day/i, start: [5, 1], end: [6, 15] },
  { name: "4 Temmuz", re: /4th of july|fourth of july|independence day|memorial day/i, start: [5, 20], end: [7, 4] },
  { name: "Yaz", re: /\bsummer\b|beach|vacation|pool party/i, start: [5, 1], end: [8, 31] },
  { name: "Okula dönüş", re: /back to school|first day of school/i, start: [7, 1], end: [9, 15] },
];

const SHIP_DAYS = 7;

/** Sezon adi (yoksa null = yil boyu) */
export function seasonOf(text: string): Season | null {
  return SEASONS.find((s) => s.re.test(text)) ?? null;
}

/** Sezon su an satisa acik mi: [baslangic, bitis - 7 gun] araliginda */
export function seasonActive(s: Season, now = new Date()): boolean {
  const y = now.getFullYear();
  const start = new Date(y, s.start[0] - 1, s.start[1]);
  const lastSale = new Date(y, s.end[0] - 1, s.end[1] - SHIP_DAYS);
  return now >= start && now <= lastSale;
}

/** Listenin sezonu gecmis mi (yil boyu listeler hic gecmez). Birden fazla sezona uyan liste
 *  (Sukran Gunu listesinde "pumpkin") sezonlarindan biri suruyorsa gecmis SAYILMAZ. */
export function seasonPassed(text: string, now = new Date()): { season: string | null; passed: boolean } {
  const all = SEASONS.filter((x) => x.re.test(text));
  if (!all.length) return { season: null, passed: false };
  const live = all.find((x) => seasonActive(x, now));
  return { season: (live ?? all[0]).name, passed: !live };
}

/** Yeniden hazirlama sirasi (IP temizligi): sezonun satisa acilmasina kac gun var. Yil boyu ya da
 *  sezonu suren liste 0; Cadilar Bayrami 26 Ekim'de ~293 (gelecek Agustos). */
export function seasonLeadDays(text: string, now = new Date()): number {
  const all = SEASONS.filter((x) => x.re.test(text));
  if (!all.length || all.some((x) => seasonActive(x, now))) return 0;
  return Math.min(...all.map((x) => {
    let start = new Date(now.getFullYear(), x.start[0] - 1, x.start[1]);
    if (start < now) start = new Date(now.getFullYear() + 1, x.start[0] - 1, x.start[1]);
    return Math.ceil((start.getTime() - now.getTime()) / 86400000);
  }));
}
